import React, { useEffect, useState } from "react";

import VarzService from "cortex/ui/src/service/varz";
import { JsonViewer } from "cortex/ui/src/ui/json-viewer";
import { Container, Panel } from "cortex/ui/src/view/layout";

type VarzState = Record<string, any> | string;

export default function Varz() {
  const [varz, setVarz] = useState<VarzState>({});

  useEffect(() => {
    let cancelled = false;

    const fetchVarz = async () => {
      try {
        const resp = await VarzService.get();
        const data = resp?.data?.data;

        if (!cancelled && data !== undefined) {
          setVarz(data);
        }
      } catch (e: unknown) {
        const message = e instanceof Error ? e.message : String(e);
        if (!cancelled) {
          setVarz(message);
        }
      }
    };

    fetchVarz();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Container hideBox title="Cortex Varz">
      <Panel>
        <JsonViewer value={varz} />
      </Panel>
    </Container>
  );
}
